<template>
    <div>
        <div class="tw-flex tw-justify-center">
            <img class="tw-w-1/5" :src="getImageLink('detail-verification.png')" />
        </div>
        <div class="tw-flex tw-justify-center tw-mt-3">
            <div class="tw-w-full md:tw-w-7/12">
                <h3 class="tw-text-white tw-font-bold tw-text-center">
                    {{ __('purchase.almost_there') }}
                </h3>
            </div>
        </div>
        <div class="tw-flex tw-justify-center">
            <div class="tw-w-full md:tw-w-7/12">
                <small class="tw-text-white tw-text-center tw-block">
                    {{ __('purchase.complete_workperks') }}
                </small>
            </div>
        </div>
        <div class="tw-flex tw-justify-center">
            <div class="tw-w-full md:tw-w-7/12">
                <small class="tw-text-white tw-text-center tw-block">
                    {{ __('purchase.keep_moving') }}
                </small>
            </div>
        </div>
        <div class="tw-flex tw-flex-wrap tw-mt-3">
            <div class="tw-w-full md:tw-w-1/4 tw-px-2">
                <div class="tw-text-center">
                    <small class="tw-text-white tw-font-bold tw-block">
                        {{ __('attributes.num_licenses') }}
                    </small>
                </div>
                <div class="tw-text-center">
                    <small class="tw-text-white">
                        {{ currentNumLicenses }}
                    </small>
                </div>
            </div>
            <div class="tw-w-full md:tw-w-1/4 tw-px-2">
                <div class="tw-text-center">
                    <small class="tw-text-white tw-font-bold tw-block">
                        {{ __('attributes.business_name') }}
                    </small>
                </div>
                <div class="tw-text-center">
                    <small class="tw-text-white">
                        {{ businessName }}
                    </small>
                </div>
            </div>
            <div class="tw-w-full md:tw-w-1/4 tw-px-2">
                <div class="tw-text-center">
                    <small class="tw-text-white tw-font-bold tw-block">
                        Workperks {{ __('attributes.url') }}
                    </small>
                </div>
                <div class="tw-text-center">
                    <small class="tw-text-white">
                        {{ currentUrl }}.venngo.com
                    </small>
                </div>
            </div>
            <div class="tw-w-full md:tw-w-1/4 tw-px-2">
                <div class="tw-text-center">
                    <small class="tw-text-white tw-font-bold tw-block">
                        {{ __('attributes.referral_name') }}
                    </small>
                </div>
                <div class="tw-text-center">
                    <small class="tw-text-white">
                        {{ referralName }}
                    </small>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { reactive, getCurrentInstance } from 'vue';

const instance = getCurrentInstance();
const __ = instance?.appContext.config.globalProperties.__;

interface Props {
    referralName?: string;
    currentNumLicenses: number;
    businessName: string;
    currentUrl: string;
}

interface CardInformation {
    number: string | null;
    last12Digits: string | null;
    firstFourDigits: string | null;
    lastFourDigits: string | null;
    cardholderName: string | null;
    expiry: string | null;
    cvv: string | null;
    cardType: string | null;
    cardTypeImage: string;
}

const props = withDefaults(defineProps<Props>(), {
    referralName: "",
    currentNumLicenses: 0,
    businessName: "",
    currentUrl: "",
});

const emit = defineEmits<{
    'previous-component': [];
    'card-information-did-submit': [cardInfo: CardInformation];
}>();

// Reactive data
const cardInformation = reactive<CardInformation>({
    number: null,
    last12Digits: null,
    firstFourDigits: null,
    lastFourDigits: null,
    cardholderName: null,
    expiry: null,
    cvv: null,
    cardType: null,
    cardTypeImage: "/marketing/smb/payment/other.png",
});

// Methods
const getImageLink = (imageFileName: string): string => {
    return `${window.s.assetPath}/${imageFileName}`;
};

const backBtnDidClick = () => {
    emit('previous-component');
};

const formWillSubmit = () => {
    emit('card-information-did-submit', cardInformation);
};

defineExpose({
    backBtnDidClick,
    formWillSubmit,
    getImageLink,
});
</script>

